<section class="faq">
  <header class="faq__header">
    <h2 class="faq__title">{{ 'faq.title' | t }}</h2>
  </header>

  <div class="faq__list">
    @for (item of items; track item.id) {
      <article class="faq__item">
        <button type="button" class="faq__question" (click)="toggle(item.id)">
          <span>{{ ('faq.items.' + item.id + '.question') | t }}</span>
          <span class="faq__icon">@if (isOpen(item.id)) { - } @else { + }</span>
        </button>

        @if (isOpen(item.id)) {
          <p class="faq__answer">{{ ('faq.items.' + item.id + '.answer') | t }}</p>
        }
      </article>
    }
  </div>
</section>
